export enum WorkersCompensation {
    NOT_APPLICABLE = 'N/A',
    FILED_DECISION_PENDING = 'Filed, decision pending',
    AWARDED = 'Awarded',
    DENIED = 'Denied'
}